import React, { type ReactNode } from "react";
import { Shield } from "lucide-react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { hasSuperAdminAccess, type SuperAdminSession } from "@shared/superAdminAccess";

export function SuperAdminAccessGate({ isAuthenticated, user, children }: { isAuthenticated: boolean; user: SuperAdminSession | null | undefined; children: ReactNode }) {
  if (isAuthenticated && hasSuperAdminAccess(user)) return <>{children}</>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Shield className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
        <h1 className="text-2xl font-light mb-2">Acesso Restrito</h1>
        <p className="text-muted-foreground mb-4">Esta área é exclusiva para o super administrador da plataforma.</p>
        <Link href="/"><Button variant="outline">Voltar ao Início</Button></Link>
      </div>
    </div>
  );
}
